import Vue from 'vue'
import route from '../router/index.js'

function wxConfig(form) {
  let url = form.url
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.wxConfig({
      url
    }).then(e => {
      wx.config({
        debug: false,
        appId: e.package.appId,
        timestamp: e.package.timestamp,
        nonceStr: e.package.nonceStr,
        signature: e.package.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
      });
      wx.onMenuShareAppMessage({
        title: e.package.wxtitle,
        desc: e.package.des,
        link: url,
        imgUrl: e.package.icon,
        success: function() {
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });
      wx.onMenuShareTimeline({
        title: e.package.wxtitle, // 分享标题
        link: url, // 分享链接
        imgUrl: e.package.icon, // 分享图标
        success: function() {

        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });
      resolve(e.package)
    })
  })
}


function share(opt = {}) {
  let title = '浦辉-云南之蓝'
  let url = location.href
  var form = {
    url,
    sid: 1,
    skey: 1,
    category_id: route.history.current.meta.category_id || ''
  }
  wxConfig(form).then(e => {

  })
}


export default function init(Vue) {
  Object.defineProperties(Vue.prototype, {
    $share: {
      get: () => share
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/tool.js